import { render, staticRenderFns } from "./ModalAlterarMateriais.vue?vue&type=template&id=4bcb2d36&scoped=true"
import script from "./ModalAlterarMateriais.vue?vue&type=script&lang=ts"
export * from "./ModalAlterarMateriais.vue?vue&type=script&lang=ts"
import style0 from "./ModalAlterarMateriais.vue?vue&type=style&index=0&id=4bcb2d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb2d36",
  null
  
)

export default component.exports